import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

function Modal({
  children,
  title,
  showModal,
  setShowModal,
  sendLabel,
  cancelLabel,
  onSubmit,
  withSubmitButton = true,
  footer,
  center = true,
  zIndex = null,
}) {
  const { t } = useTranslation();

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [showModal]);

  return (
    <>
      {showModal ? (
        <>
          <div
            className={`mx-4 lg:mx-0 justify-center top-50 flex overflow-x-hidden overflow-y-auto fixed inset-0 ${
              zIndex ? zIndex : "z-40"
            } outline-none focus:outline-none ${
              center ? "items-center" : "items-top"
            }`}
          >
            <div className="relative w-full my-6 mx-auto lg:max-w-3xl">
              <div
                className={`border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none ${
                  !center && "mb-10"
                }`}
              >
                <div className="flex items-center justify-between p-4 px-8 rounded-t bg-bioport-blue-light text-white">
                  <h3 className="text-xl">{title}</h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-white float-right text-2xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="bg-transparent text-white h-6 w-6 text-xl block outline-none focus:outline-none">
                      <FontAwesomeIcon
                        icon={faTimes}
                        className="cursor-pointer"
                      />
                    </span>
                  </button>
                </div>

                <div className="relative p-6 flex-auto">{children}</div>

                {footer !== false && (
                  <div className="p-6 border-t border-solid border-gray-200 rounded-b">
                    {footer ? (
                      footer
                    ) : (
                      <div className="flex justify-end">
                        <div
                          className="btn btn-secondary cursor-pointer"
                          onClick={() => setShowModal(false)}
                        >
                          {cancelLabel || t("global.btn.cancel")}
                        </div>

                        {withSubmitButton && (
                          <div
                            className="btn btn-primary cursor-pointer ml-2"
                            onClick={onSubmit}
                          >
                            {sendLabel || t("global.btn.send")}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-30 bg-black"></div>
        </>
      ) : null}
    </>
  );
}

export default Modal;
